import { render, staticRenderFns } from "./morehave.vue?vue&type=template&id=0914e978&scoped=true"
import script from "./morehave.vue?vue&type=script&lang=js"
export * from "./morehave.vue?vue&type=script&lang=js"
import style0 from "./morehave.vue?vue&type=style&index=0&id=0914e978&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0914e978",
  null
  
)

export default component.exports